export const groupColor = {
	black: {
		hover: 'hover:bg-trackdesk-dark/30 dark:hover:bg-trackdesk-dark/70 text-dark dark:text-white',
		selected: 'bg-trackdesk-dark text-white',
		transparent: 'bg-trackdesk-dark/30',
	},
	green: {
		hover: 'hover:bg-trackdesk-green/30 dark:hover:bg-trackdesk-green/70',
		selected: 'bg-trackdesk-green text-white',
		transparent: 'bg-trackdesk-green/30',
	},
	orange: {
		hover: 'hover:bg-orange-trackdesk/30 dark:hover:bg-orange-trackdesk/70',
		selected: 'bg-orange-trackdesk',
		transparent: 'bg-orange-trackdesk/30',
	},
	blue: {
		hover: 'hover:bg-blue-trackdesk/40 dark:hover:bg-blue-trackdesk/70',
		selected: 'bg-blue-trackdesk',
		transparent: 'bg-blue-trackdesk/30',
	},
}
